import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const services = [
  {
    id: 1,
    title: 'Birthday Decorations',
    image: '/gallery/image.jpg',
    alt: 'Birthday Decoration Service'
  },
  {
    id: 2,
    title: 'Anniversary Setups',
    image: '/gallery/image2.jpg',
    alt: 'Anniversary Decoration Service'
  },
  {
    id: 3,
    title: 'Baby Shower Themes',
    image: '/gallery/image3.jpg',
    alt: 'Baby Shower Decoration'
  },
  {
    id: 4,
    title: 'Welcome Baby Decorations',
    image: '/gallery/image4.jpg',
    alt: 'Welcome Baby Decoration'
  },
  {
    id: 5,
    title: 'Kids Theme Parties',
    image: '/images/image2.jpg',
    alt: 'Kids Theme Decoration'
  },
  {
    id: 6,
    title: 'Premium Decorations',
    image: '/gallery/image.jpg',
    alt: 'Premium Decoration Service'
  },
  {
    id: 7,
    title: 'Romantic Canopy Setup',
    image: '/gallery/image3.jpg',
    alt: 'Romantic Canopy Decoration'
  },
  {
    id: 8,
    title: 'Bachelorette Parties',
    image: '/gallery/image4.jpg',
    alt: 'Bachelorette Party Decoration'
  }
];

const ServicesSlider = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-4" style={{ color: 'var(--primary-dark)' }}>
          Our Decoration Services
        </h2>
        <p className="text-center max-w-2xl mx-auto mb-12 text-gray-600">
          Transform your special occasions with our premium decoration services tailored to your needs
        </p>
        
        <div className="relative">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            className="mySwiper"
          >
            {services.map((service) => (
              <SwiperSlide key={service.id}>
                <div className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 bg-white group">
                  <div className="h-52 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.alt}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-all duration-300"
                    />
                  </div>
                  <div className="py-4 px-3">
                    <h4 className="font-medium text-center text-lg" style={{ color: 'var(--primary)' }}>
                      {service.title}
                    </h4>
                  </div>
                  <div 
                    className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent h-12 flex items-end justify-center pb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <span className="text-white text-sm font-medium"></span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button className="swiper-button-prev absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 z-10 rounded-full p-3 shadow-lg transition-colors" style={{ backgroundColor: 'var(--primary)', color: 'white' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          
          <button className="swiper-button-next absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-10 rounded-full p-3 shadow-lg transition-colors" style={{ backgroundColor: 'var(--primary)', color: 'white' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSlider; 